import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Usd = function Usd(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#USD_svg__USD_svg__clip0_9086_35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.405 12.75v-.723c1.651-.13 2.597-.979 2.597-2.34 0-1.154-.678-1.854-2.056-2.182l-.541-.115V5.12c.667.088 1.132.547 1.148 1.127h1.307c-.027-1.23-.979-2.111-2.455-2.242V3.25H7.65v.755c-1.548.136-2.477.979-2.477 2.27 0 1.093.689 1.837 1.952 2.143l.525.131v2.39c-.771-.087-1.269-.53-1.318-1.154H4.998c.005 1.29 1.022 2.15 2.652 2.253v.711h.755zm1.268-2.921c0 .656-.464 1.072-1.268 1.121V8.691c.87.175 1.268.536 1.268 1.138zM6.518 6.165c0-.58.476-1.012 1.132-1.05V7.23c-.738-.153-1.132-.52-1.132-1.066z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "USD_svg__USD_svg__clip0_9086_35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default Usd;